function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 5.88431,
  width: 1,
  height: 6,
  rx: 0.5,
  className: "FillColor",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 10,
  width: 1,
  height: 8,
  rx: 0.5,
  className: "FillColor",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 10,
  width: 1,
  height: 8,
  rx: 0.5,
  className: "FillColor",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 5.88431,
  width: 1,
  height: 6,
  rx: 0.5,
  className: "FillColor",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M2 6C2 5.44772 2.44772 5 3 5H5C5.55228 5 6 5.44772 6 6V12H2V6Z",
  className: "FillColor",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 2,
  r: 2,
  className: "FillColor",
  fill: "black"
});

var SvgHuman = function SvgHuman(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 18,
    viewBox: "0 0 8 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHuman, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/human.da4666ad.svg";
export { ForwardRef as ReactComponent };